import { z } from "zod";
import "../zod-runtime.js";
/**
 * Das vollständige Vokabular der Fehlercodes, die die API ausliefert.
 *
 * Bewusst als `z.enum` und nicht als `z.string()`: Server und Web teilen sich
 * diese Liste. Der Server bildet seine Domänenfehler darauf ab, das Web
 * unterscheidet daran seine Meldungen. Ein Code, den nur eine Seite kennt,
 * wird damit zum Typfehler statt zu einem stillen Fallback.
 *
 * Reihenfolge nach Anlass, nicht alphabetisch — verwandte Codes stehen
 * beieinander.
 */
export const apiErrorCodeSchema = z.enum([
    // Allgemein
    "BAD_REQUEST",
    "NOT_FOUND",
    "INTERNAL_ERROR",
    "NOT_READY",
    // Authentifizierung und Autorisierung
    "UNAUTHENTICATED",
    "UNAUTHORIZED",
    "FORBIDDEN",
    "READ_ONLY",
    "CSRF_REJECTED",
    "ORIGIN_REJECTED",
    "LOGIN_FAILED",
    "REFRESH_FAILED",
    "NO_REFRESH_TOKEN",
    "MEMBER_DISABLED",
    "PASSWORD_REJECTED",
    "RESET_TOKEN_INVALID",
    "INVITE_FAILED",
    "LAST_CAPTAIN",
    // Optimistisches Sperren und Konflikte
    "VERSION_CONFLICT",
    "ID_MISMATCH",
    "UTILITY_IN_USE",
    "UTILITY_VISIBILITY_CONFLICT",
    "PUBLISH_CONFLICT",
    // Fachliche Ablehnungen
    "VALIDATION_FAILED",
    "APPROVAL_REJECTED",
    "NOTHING_TO_PUBLISH",
    "NO_SNAPSHOT",
    // Medien
    "FILE_REQUIRED",
    "CROP_REQUIRED",
    "FILE_TOO_LARGE",
    "IMAGE_TOO_LARGE",
    "CROP_ASPECT_INVALID",
    "MEDIA_UNAVAILABLE",
    // Granatenphysik
    "PHYSICS_UNAVAILABLE",
    "PHYSICS_SURFACE_NOT_FOUND",
]);
export const apiErrorSchema = z.object({
    code: apiErrorCodeSchema,
    message: z.string(),
    /**
     * Begründungen einer fachlichen Ablehnung — etwa die Liste der Gründe, warum
     * eine Freigabe scheitert, oder die Namen der Taktiken, die das Löschen einer
     * Utility blockieren. Für die Anzeige gedacht.
     */
    details: z.array(z.string()).optional(),
    /**
     * Der serverseitige Stand bei einem Versionskonflikt. Getrennt von `details`,
     * weil beides fachlich verschieden ist: `details` erklärt dem Menschen die
     * Ablehnung, `current` erlaubt der Oberfläche, den Konflikt aufzulösen.
     */
    current: z.unknown().optional(),
});
